// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__yZvcv","productName":"Table_productName__25aqX"};